import createResponseFromModernGroupOperation from 'owa-service/lib/operation/createResponseFromModernGroupOperation';
import createResponseFromModernGroupRequest from 'owa-service/lib/factory/createResponseFromModernGroupRequest';
import itemResponseShape from 'owa-service/lib/factory/itemResponseShape';
import propertyUri from 'owa-service/lib/factory/propertyUri';
import { getComposeItemResponseShape } from '../utils/getItemResponseShape';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
function createRequestBodyFromItem(itemType, bodyType, isSend, timeFormat, isInlineCompose) {
    var request = createResponseFromModernGroupRequest({
        ClientSupportsIrm: false,
        ComposeOperation: 'newPost',
        MessageDisposition: isSend ? 'SendAndSaveCopy' : 'SaveOnly',
        OutboundCharset: 'AutoDetect',
        Items: [itemType],
        TimeFormat: timeFormat,
        ItemShape: itemResponseShape({
            // Pass IdOnly as ShapeName here so that the response will contain LastModifiedTime
            BaseShape: 'IdOnly',
            AdditionalProperties: [propertyUri({ FieldURI: 'ItemLastModifiedTime' })],
        }),
    });
    if (!isSend) {
        request.ItemShape = getComposeItemResponseShape(bodyType);
        request.ShapeName = 'MailCompose';
    }
    else if (isInlineCompose) {
        // If sending from inlineCompose, request the internetMessageId in case we don't have it yet.
        request.ItemShape.ReturnOnlyInternetMessageId = true;
    }
    return request;
}
export default function createResponseFromGroup(itemType, bodyType, isSend, timeFormat, isInlineCompose) {
    var requestBody = createRequestBodyFromItem(itemType, bodyType, isSend, timeFormat, isInlineCompose);
    return createResponseFromModernGroupOperation({
        Header: getJsonRequestHeader(),
        Body: requestBody,
    }).then(function (response) {
        return response
            ? Promise.resolve(response.Body)
            : Promise.reject(new Error('ErrorSessionTimeout')); // When get HTTP 401/440, the response will be null
    });
}
//# sourceMappingURL=createResponseFromModernGroupItem.js.map